// libraries
import React from 'react';
import Route from 'react-router/lib/Route';
import store from 'store';

// actions
import {
  handleAdminHomeRouteEnter,
  handleAuditHomeRouteEnter,
  handleAuditEntryRouteEnter,
  handleAuditVirtualEntryRouteEnter,
  handleAuditBowlerRouteEnter,
  handleAuditTournamentRouteEnter,
  handleAuditCaptainRouteEnter,
  handleAdminBackToSearchRouteEnter,
  handleAdminSquadsRouteEnter,
  handleAdminReviewRouteEnter,
  handleAdminEntryDetailRouteEnter,
  handleAdminCaptainDetailRouteEnter,
  handleAdminVirtualEventDetailRouteEnter
} from './actions';

// components
import AdminHome from './home/AdminHome.jsx';
import AuditHomeContainer from './audit/AuditHomeContainer.jsx';
import AuditSearchEntryDetailListContainer from './audit/entryAudit/AuditSearchEntryDetailListContainer.jsx';
import AuditSearchVirtualEntryDetailListContainer from './audit/virtualEntryAudit/AuditVirtualEntryDetailListContainer.jsx';
import AuditBowlerDetailListContainer from './audit/bowlerAudit/AuditBowlerDetailListContainer.jsx';
import AuditTournamentDetailListContainer from './audit/tournamentAudit/AuditTournamentDetailListContainer.jsx';
import AuditCaptainDetailListContainer from './audit/captainAudit/AuditCaptainDetailListContainer.jsx';
import ReserveSquadsContainer from './schedule/ReserveSquadsContainer.jsx';
import ReservationReviewContainer from './review/ReservationReviewContainer.jsx';
import EntryDetailContainer from './entryDetail/EntryDetailContainer.jsx';
import CaptainDetailContainer from './captainDetail/CaptainDetailContainer.jsx';
import VirtualEventDetail from './virtualEventDetail/VirtualEventDetail.jsx';

const adminRole = "superuser,admin";
const adminOrManagerRole = "superuser,admin,manager";

const routes = (
  <div>
    <Route path="admin"
      role={adminRole}
      component={AdminHome}
      onEnter={(nextState, replace, callback) =>
        store.dispatch(handleAdminHomeRouteEnter(nextState, replace, callback))}
    />
    <Route path="admin/search"
      role={adminRole}
      component={AdminHome}
      onEnter={(nextState, replace, callback) =>
        store.dispatch(handleAdminBackToSearchRouteEnter(nextState, replace, callback))}
    />
    <Route path="admin/audit"
      role={adminOrManagerRole}
      component={AuditHomeContainer}
      onEnter={(nextState, replace, callback) =>
        store.dispatch(handleAuditHomeRouteEnter(nextState, replace, callback))}
    />
    <Route path="admin/audit/entry/:entryId"
      role={adminOrManagerRole}
      component={AuditSearchEntryDetailListContainer}
      onEnter={(nextState, replace, callback) =>
        store.dispatch(handleAuditEntryRouteEnter(nextState, replace, callback))}
    />
    <Route path="admin/audit/virtualEntry/:virtualEntryId"
      role={adminOrManagerRole}
      component={AuditSearchVirtualEntryDetailListContainer}
      onEnter={(nextState, replace, callback) =>
        store.dispatch(handleAuditVirtualEntryRouteEnter(nextState, replace, callback))}
    />
    <Route path="admin/audit/bowler/:bowlerId"
      role={adminOrManagerRole}
      component={AuditBowlerDetailListContainer}
      onEnter={(nextState, replace, callback) =>
        store.dispatch(handleAuditBowlerRouteEnter(nextState, replace, callback))}
    />
    <Route path="admin/audit/tournament/:tournamentId"
      role={adminOrManagerRole}
      component={AuditTournamentDetailListContainer}
      onEnter={(nextState, replace, callback) =>
        store.dispatch(handleAuditTournamentRouteEnter(nextState, replace, callback))}
    />
    <Route path="admin/audit/captain/:captainId/:tournamentId"
      role={adminOrManagerRole}
      component={AuditCaptainDetailListContainer}
      onEnter={(nextState, replace, callback) =>
        store.dispatch(handleAuditCaptainRouteEnter(nextState, replace, callback))}
    />
    <Route path="admin/squads"
      role={adminRole}
      component={ReserveSquadsContainer}
      onEnter={(nextState, replace, callback) =>
        store.dispatch(handleAdminSquadsRouteEnter(nextState, replace, callback))}
    />
    <Route path="admin/review/:tournamentId"
      role={adminRole}
      component={ReservationReviewContainer}
      onEnter={(nextState, replace, callback) =>
        store.dispatch(handleAdminReviewRouteEnter(nextState, replace, callback))}
    />
    <Route path="admin/entry/:entryId"
      role={adminRole}
      component={EntryDetailContainer}
      onEnter={(nextState, replace, callback) =>
        store.dispatch(handleAdminEntryDetailRouteEnter(nextState, replace, callback))}
    />
    <Route path="admin/entry/:entryId/:paymentId"
      role={adminRole}
      component={EntryDetailContainer}
      onEnter={(nextState, replace, callback) =>
        store.dispatch(handleAdminEntryDetailRouteEnter(nextState, replace, callback))}
    />
    <Route path="admin/captain/:captainId"
      role={adminRole}
      component={CaptainDetailContainer}
      onEnter={(nextState, replace, callback) =>
        store.dispatch(handleAdminCaptainDetailRouteEnter(nextState, replace, callback))}
    />
    <Route path="admin/captain/:captainId/:paymentId"
      role={adminRole}
      component={CaptainDetailContainer}
      onEnter={(nextState, replace, callback) =>
        store.dispatch(handleAdminCaptainDetailRouteEnter(nextState, replace, callback))}
    />
    <Route path="admin/captain/:captainId/virtualevent/:virtualEventId"
      role={adminRole}
      component={VirtualEventDetail}
      onEnter={(nextState, replace, callback) =>
        store.dispatch(handleAdminVirtualEventDetailRouteEnter(nextState, replace, callback))}
    />
    <Route path="admin/captain/:captainId/virtualevent/:virtualEventId/:paymentId"
      role={adminRole}
      component={VirtualEventDetail}
      onEnter={(nextState, replace, callback) =>
        store.dispatch(handleAdminVirtualEventDetailRouteEnter(nextState, replace, callback))}
    />
  </div>
);

export default routes;



// WEBPACK FOOTER //
// ./src/features/admin/routes.js